import type { IHeaderCommon } from '@carnica/smart-kit';

export const selectHeaderData = (state: any) => state.specialProjectHeader;
export const selectHeaderTheme = (state: any) => selectHeaderData(state)?.layout?.theme;
export const selectHeaderCommon = (state: any) => selectHeaderData(state)?.common as IHeaderCommon;
export const selectIsHeaderModelLoaded = (state: any) => selectHeaderCommon(state)?.loaded;
export const selectHeaderUser = (state: any) => selectHeaderCommon(state)?.auth?.user;
